import graphql__04f885adc050d029b9dc from "./__generated__/AnswerCheckBoxes_answer.graphql.js";import { graphql, useFragment } from "react-relay";

import RadioButtonsField from "../Form/Field/RadioButtonsField";
import CheckBoxesField from "../Form/Field/CheckBoxesField";
import CheckboxesSelectField from "../Form/Field/CheckboxesSelectField";
import CheckboxesMultiSelectField from "../Form/Field/CheckboxesMultiSelectField";
import {
  CHECKBOXES,
  CHECKBOXES_MULTI_SELECT,
  CHECKBOXES_SELECT,
  RADIOS
} from "../Form/SchemaTypes";

const FIELD_TYPES = {
  checkboxesSelect: CheckboxesSelectField,
  checkboxesMultiSelect: CheckboxesMultiSelectField,
  radios: RadioButtonsField,
  checkboxes: CheckBoxesField
};

const SELECTABLE_TYPE_LIST = "list";

const AnswerCheckBoxes = function (props) {
  const answer = useFragment(AnswerCheckBoxes_answer, props.answer);
  const { values, other, otherValue, formField } = answer;
  const {
    fieldName,
    label,
    required,
    hintPosition,
    listedOptions,
    displayOtherField,
    otherFieldLabel,
    hide,
    maximumSelectableOptions,
    selectableType,
    singleOptionSelection
  } = formField;
  const { parent, isCorrection, correctionTextOnlyOnWrongAnswers } = props;

  // If we're in correction mode, don't display the global field hint as it can be mixed
  // with the correction hints
  const hint = !isCorrection && formField.hint;

  let type;

  if (selectableType === SELECTABLE_TYPE_LIST && !isCorrection) {
    type = singleOptionSelection ? CHECKBOXES_SELECT : CHECKBOXES_MULTI_SELECT;
  } else {
    type = singleOptionSelection ? RADIOS : CHECKBOXES;
  }

  const FieldType = FIELD_TYPES[type];

  const filterUnusedOptions = isCorrection && selectableType === SELECTABLE_TYPE_LIST;

  return (
    <FieldType
      fieldName={fieldName}
      label={label}
      required={required}
      hint={hint}
      hintPosition={hintPosition}
      hide={hide}
      parent={parent}
      options={listedOptions}
      displayOtherField={displayOtherField}
      otherFieldLabel={otherFieldLabel}
      defaultValues={values}
      defaultOther={other}
      defaultOtherValue={otherValue}
      isCorrection={isCorrection}
      correctionTextOnlyOnWrongAnswers={correctionTextOnlyOnWrongAnswers}
      maximumSelectableOptions={maximumSelectableOptions}
      filterUnusedOptions={filterUnusedOptions}
      answer={answer}
    />
  );
};

const AnswerCheckBoxes_answer = graphql__04f885adc050d029b9dc;

export default AnswerCheckBoxes;
